import { createMutationAtom } from 'atoms/create-resource-atom';
import request from 'lib/request';
import {
  StructureGridHeadersResponse,
  StructureGridValidationResponse,
} from 'types/api-responses';

let cachedHeadersPromise: Promise<
  StructureGridHeadersResponse | undefined
> | null = null;

export const getStructureGridHeaders = (): Promise<
  StructureGridHeadersResponse | undefined
> => {
  if (!cachedHeadersPromise) {
    // Define the endpoint
    const endpoint = '/structure_grids/headers';

    // Create and cache the promise - remove async from the executor function
    cachedHeadersPromise = new Promise((resolve) => {
      // Move the async to the inner function
      request
        .get<StructureGridHeadersResponse>(endpoint)
        .then((response) => {
          if (!response || 'error' in response) {
            console.error(
              'Error fetching structure grid headers:',
              'error' in response ? response.error : 'Unknown error'
            );
            resolve(undefined);
            return;
          }

          resolve(response);
        })
        .catch((error) => {
          console.error('Failed to fetch structure grid headers:', error);
          resolve(undefined);
        });
    });
  }

  return cachedHeadersPromise;
};

const structureGridValidationAtom = createMutationAtom<
  StructureGridValidationResponse,
  'structureGrids'
>();

export { structureGridValidationAtom };
